import { tool } from "../../constants/tool";
import React, { useState } from "react";
const Tool = () => {
  const [showAll, setShowAll] = useState(false);

  const visibleTools = showAll ? tool : tool.slice(0, 6);
  return (
    <div className="mt-5">
      <h2 className="text-uppercase fw-bold text-center">My Tech Stack</h2>
      <h5 className="text-center m-3">
        My tech stack includes modern frameworks, languages, and development
        tools that enable me to build efficient and scalable applications.
      </h5>
      <div className="row g-4 px-3">
        {visibleTools.map((items, index) => (
          <div key={index} className="col-6 col-sm-2 col-md-2">
            <div className="card h-100 border-0 shadow-sm hover-shadow rounded-4 text-center p-3 transition">
              <img
                src={items.img}
                alt="tool"
                className="card-img-top img-fluid mx-auto"
                style={{
                  width: "64px",
                  height: "64px",
                  objectFit: "contain",
                  transition: "transform 0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
              <p className="mt-2 fw-medium">{items.title}</p>
            </div>
          </div>
        ))}
      </div>
      {tool.length > 6 && (
        <div className="text-center mt-4">
          <button
            className="btn btn-outline-info px-4 fw-bold"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "See Less" : "See More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Tool;
